module.exports = __webpack_public_path__ + "officialStatic/fonts/PingFangSCExtraLight.f633c68.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/woff2/PingFangSCExtraLight.woff2
// module id = YvnW
// module chunks = 0